import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import {
  IUpdateVehiclePricingMatrixRequest,
  IVehicleKtypePricingResponse,
  IVehiclePricingMatrixResponse,
} from "../models/account/IAccountPartPricingMatrix";
import apiConfig from "../utils/apiConfig";

export default function useVehiclePricingMatrix(
  vehicleId?: string,
  componentName = "useVehiclePricingMatrix"
) {
  const { get, put } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();
  const queryKey = ["vehicles", vehicleId, "pricing-matrix"];

  const vehiclePricingMatrix = useQuery({
    queryKey,
    queryFn: () =>
      get<IVehiclePricingMatrixResponse>(`/part/vehicle/${vehicleId}/pricing-matrix`),
    enabled: !!vehicleId,
  });

  const vehicleKtypePricing = useQuery({
    queryKey: ["vehicles", vehicleId, "ktype-pricing"],
    queryFn: () =>
      get<IVehicleKtypePricingResponse>(`/part/vehicle/${vehicleId}/ktype-pricing`),
    enabled: !!vehicleId,
  });

  const updateVehiclePricingMatrix = useMutation({
    mutationFn: (req: IUpdateVehiclePricingMatrixRequest) =>
      put(`/part/vehicle/${vehicleId}/account-pricing`, req),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKey);
    },
  });

  return {
    vehiclePricingMatrix,
    vehicleKtypePricing,
    updateVehiclePricingMatrix,
  };
}
